<template>
  <div class="section">
    <div class="ui container">
      <div class="ui stackable equal width grid">
        <div class="equal width row primary">
          <div class="middle aligned column">
            <a href="http://www.coindesk.com/dao-manager-aragon-alpha-ethereum/" target="_blank" rel="noopener noreferrer"><img class="ui fluid tiny centered image" src="../assets/media/coindesk.png"></a>
          </div>
          <div class="middle aligned column">
            <a href="https://www.financemagnates.com/cryptocurrency/news/dao-reborn-aragon-launches-crowdsale-decentralized-organizations/" target="_blank" rel="noopener noreferrer"><img class="ui fluid tiny centered image" src="../assets/media/financemagnates.png"></a>
          </div>
          <div class="middle aligned column">
            <a href="https://www.forbes.com/sites/rogeraitken/2017/04/20/forbes-under-30-tech-prodigy-in-cryptosale-for-decentralized-jurisdiction-platform/#3ac1df126a12" target="_blank" rel="noopener noreferrer"><img class="ui fluid tiny centered image" src="../assets/media/forbes.png"></a>
          </div>
          <div class="middle aligned column">
            <a href="https://cointelegraph.com/news/spains-aragon-joins-ethereum-startups-eyeing-token-sale-glory" target="_blank" rel="noopener noreferrer"><img class="ui fluid tiny centered image" src="../assets/media/cointelegraph.png"></a>
          </div>
          <div class="middle aligned column">
            <a href="https://finance.yahoo.com/m/12f8484f-3af2-370d-b6e7-f2cada14bf5f/forbes-%27under-30%27-tech.html" target="_blank" rel="noopener noreferrer"><img class="ui fluid tiny centered image" src="../assets/media/yahoo.png"></a>
          </div>
          <div class="middle aligned column">
            <a href="http://coinjournal.net/ethereum-platform-aragon-power-next-gen-decentralized-organizations/" target="_blank" rel="noopener noreferrer"><img class="ui fluid tiny centered image" src="../assets/media/coinjournal.png"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'media',
}
</script>

<style scoped>
.section {
  padding: 2.5rem 0 !important;
  background: #fafafa;
}
img {
  filter: grayscale(100%);
}
</style>



// WEBPACK FOOTER //
// Media.vue?307a4aa4